import React from 'react';
import PropTypes from 'prop-types';

const ErrorBox = (props) => {
  const { errors } = props;

  return errors.map((error) => (
    <p className="notice" id="login-error-notice" key={error.message}>
      {error.message}
    </p>
  ));
};

ErrorBox.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ErrorBox;
